import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { MplRadioButton } from '@mopla/ui';

import { IBankAccount, ITrueLayerReport } from '../../types';

interface IProps {
	accounts?: ITrueLayerReport[];
	bankAccount: IBankAccount;
	handleOnChange: (value: IBankAccount) => void;
}

export const ValidationStep: FC<IProps> = ({
	accounts,
	handleOnChange,
	bankAccount,
}) => {
	const { t } = useTranslation('openBanking');

	return (
		<Stack gap={2} sx={{ mt: 2 }}>
			<Typography variant="h4-sb" color="primary.main">
				{t('validation')}
			</Typography>

			<Stack gap={2}>
				{accounts?.map((account) => (
					<MplRadioButton
						key={account?.iban}
						text={account.display_name ?? ''}
						subtext={account.iban ?? ''}
						checked={bankAccount.iban === account.iban}
						onChange={() =>
							handleOnChange({ ...bankAccount, iban: account.iban })
						}
						value={account.iban}
					/>
				))}
			</Stack>
		</Stack>
	);
};
